import generalInfoReducer from './generalInfoReducer';

export * from './generalInfo';
export default generalInfoReducer;
